import ApiService from './ApiService';

export default class ItemApi extends ApiService {
    getAllItem(payload) {
        return this.get('item', payload);
    }

    getItemById(id) {
        return this.get(`item/${id}`);
    }

    addItem(payload) {
        return this.post('item', payload);
    }

    updateItem(payload) {
        const { id, data } = payload;
        return this.put(`item/${id}`, data);
    }

    deleteItem(id) {
        return this.delete(`item/${id}`);
    }

    approveItem(id) {
        return this.put(`item-approve/${id}`);
    }

    rejectItem(data) {
        const { id, payload } = data;
        return this.put(`item-reject/${id}`, payload);
    }

    uploadImage(payload) {
        return this.post('file', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    };

    uploadFileExcel(payload) {
        return this.post('import-file-excel', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
}
